import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-development',
  templateUrl: './development.component.html',
  styleUrls: ['./development.component.scss', './development.component.media.scss']
})
export class DevelopmentComponent implements OnInit {
  srcArr = [
    './assets/diandu-1.jpg',
    './assets/diandu-2.jpg',
    './assets/diandu-3.jpg',
    './assets/diandu-4.jpg'
  ];
  showImg = false;
  showImgInd = 0;
  qualityArr = [
    {
      title: 'Mould workshop',
      src: './assets/muju-1.jpg',
      srcArr: [
        './assets/muju-1.jpg'
      ],
      content: 'First-class mold makes the first-class products, in the 20 years of experience accumulated basis , HUARI  got a good theory of mold design and manufacturing. Within the instantly innovation , HUARI strictly control mold quality, achieve to the excellence'
    },
    {
      title: 'Die casting workshop',
      src: './assets/yazhu-1.jpg',
      srcArr: [
        './assets/yazhu-1.jpg',
        './assets/yazhu-2.jpg'
      ],
      content: 'Huari has 10 sets of the die casting machines ranging from100T to 1600T, all with the the autonomous robots.Otherwise , we have the vacuum die casting equipment to support the high porosity requirement product . To provide customers with high quality, high efficiency of the full range of services'
    },
    {
      title: 'Machining workshop',
      src: './assets/jijia-2.jpg',
      srcArr: [
        './assets/jijia-2.jpg',
        './assets/jijia-1.jpg',
        './assets/jijia-3.jpg'
      ],
      content: '40 sets of high precision CNC machining centers, CNC lathe and mills, ultrasonic cleaning equipment , to satisfy the customer requirement'
    },
    {
      title: 'Elecplating workshop',
      src: './assets/diandu-1.jpg',
      srcArr: [
        './assets/diandu-1.jpg',
        './assets/diandu-2.jpg',
        './assets/diandu-3.jpg',
        './assets/diandu-4.jpg'
      ],
      content: 'Zinc and aluminum alloy fully automatic electroplating line'
    }
  ];
  constructor() { }

  ngOnInit() {
  }
  handleShowImg(arr) {
    this.srcArr = arr;
    this.showImg = true;
    this.showImgInd = 0;
  }
}
